import directus from "@/api/services/directus";
import { StrainsListCampaignFeature } from "@/custom-types/Directus";
import createDirectusImgixUrl from "@/utils/createDirectusImgixUrl";
import logError from "@/utils/logError";

const getListCampaignSections = async () => {
  const params = {
    fields: "*,desktop_image.filename_disk,mobile_image.filename_disk",
    "filter[status][_eq]": "published",
  };

  try {
    const { data = [] } = await directus.get<StrainsListCampaignFeature[]>(
      "strains_list_campaign_feature",
      {
        params,
      },
    );

    const campaignFeature = data?.length && data[0];
    if (campaignFeature) {
      return {
        ...campaignFeature,
        desktop_image: campaignFeature.desktop_image
          ? createDirectusImgixUrl(campaignFeature.desktop_image.filename_disk)
          : null,
        mobile_image: campaignFeature.mobile_image
          ? createDirectusImgixUrl(campaignFeature.mobile_image.filename_disk)
          : null,
      };
    } else {
      return {};
    }
  } catch (e) {
    logError(e.message, {
      functionName: "getListCampaignSections",
      service: "directus",
      statusCode: e.statusCode,
    });

    return {};
  }
};

export default getListCampaignSections;
